import { localize } from 'vee-validate'
let locales = require ("@/lang/locales.js");

let langs = {};

locales.default.locales.map(item => {
  window[`${item.code}`] = require (`vee-validate/dist/locale/${item.code}.json`);
  langs[item.code] = window[`${item.code}`];
})

export default function ({ app, store }) {
  // beforeLanguageSwitch called right before setting a new locale
  app.i18n.beforeLanguageSwitch = (oldLocale, newLocale) => {
    // console.log(oldLocale, newLocale)
    // console.log(store);
    store.commit('setState', {var: 'lang', value: newLocale});
  }
  // onLanguageSwitched called right after a new locale has been set
  app.i18n.onLanguageSwitched = (oldLocale, newLocale) => {
    // console.log(oldLocale, newLocale);
    // console.log(store);
  }

  localize(langs);

  localize(app.i18n.loadedLanguages[0]);

  app.i18n.onLanguageSwitched = (oldLocale, newLocale) => {
    localize(newLocale)
  }
}

